import { NavLink } from 'react-router';

export function DrawerNav() {
  return (
    <nav aria-label="Main">
      <ul>
        <li>
          <NavLink to="/" end>
            New paste
          </NavLink>
        </li>
        <li>
          <NavLink to="/mine">My pastes</NavLink>
        </li>
      </ul>
    </nav>
  );
}
